import { Component } from 'preact';
import style from './style';
import Image from '@components/image';
import Button from '@components/button';
import Popover from '@components/popover';
import { countryCodes } from './countryCodes';
import { CountryCodeSelectorDisplay } from './CountryCodeSelectorDisplay';

export class CountryCodeSelector extends Component {
  render({ onChange, contact_info }, { autocomplete = '' }, { lang }) {
    const code = (
      contact_info.country_code
        ? contact_info.country_code
        : lang === 'en'
        ? 'fi'
        : lang
    ).toLowerCase();
    return (
      <Popover
        toggle={
          <Button class={style.countryCodeSelectorFlag}>
            <Image
              src={`https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/${code}.svg`}
              alt={code}
              class={style.countryCodeFlagImage}
            />
            <span class={style.countryCodeToggleText}>
              {countryCodes[code]}
            </span>
          </Button>
        }
        class={style.countryCodeSelectorDisplayWrapper}
      >
        <CountryCodeSelectorDisplay
          onChange={onChange}
          contact_info={contact_info}
          autocomplete={autocomplete}
          onAutoComplete={e => this.setState({ autocomplete: e.target.value })}
        />
      </Popover>
    );
  }
}



// WEBPACK FOOTER //
// ./routes/book/CountryCodeSelector.js